import React from "react";
import { Alert, AlertTitle, Snackbar } from "@mui/material";
import {
  DeleteIcon,
  InfoIcon,
  IconBackgroundDelete,
  IconBackgroundSuccess,
  IconBackgroundInactive,
} from "components/icon";
import DoDisturbRoundedIcon from "@mui/icons-material/DoDisturbRounded";
import { isValidValue } from "utils";

const AlertUI = ({ alerts, hideAlerts }) => {
  return (
    <React.Fragment>
      {alerts.map((el) => (
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          key={el.id}
          open={true}
          autoHideDuration={el.duration}
          onClose={() => hideAlerts(el.id)}
        >
          <Alert
            severity={el.type}
            iconMapping={{
              error: (
                <IconBackgroundDelete>
                  <DeleteIcon sx={{ color: "#BC1B06" }} />
                </IconBackgroundDelete>
              ),
              success: (
                <IconBackgroundSuccess>
                  <InfoIcon sx={{ color: "#039855" }} />
                </IconBackgroundSuccess>
              ),
              warning: (
                <IconBackgroundInactive>
                  <DoDisturbRoundedIcon
                    sx={(theme) => ({
                      color: theme.palette.status.deactivated.color,
                    })}
                  />
                </IconBackgroundInactive>
              ),
            }}
            // variant="filled"
            variant="outlined"
            sx={(theme) => ({
              width: "100%",
              border: "1px solid #F2F4F7",
              background: "#ffffff",
              alignItems: "center",
              minWidth: "200px",
              "& .MuiAlertTitle-root": {
                ...theme.typography.subtitle4,
                color: "#101828",
              },
            })}
            onClose={() => hideAlerts(el.id)}
          >
            <AlertTitle
              sx={{ marginBottom: isValidValue(el.message) ? "inherit" : 0 }}
            >
              {el.title}
            </AlertTitle>
          </Alert>
        </Snackbar>
      ))}
    </React.Fragment>
  );
};

export default AlertUI;
